export default __webpack_public_path__ + "static/media/e-registro-new-login.38237ffd.jpg";